/* src/app/reports/reports.component.css */
.row {
  display: flex;
  justify-content: space-between;
}
.col {
  flex: 1;
  margin: 0 10px;
}
.btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--orange);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn.selected {
  background-color: var(--header-color);
}
a.btn {
  text-decoration: none;
}
/*# sourceMappingURL=reports.component.css.map */
